import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MongoService } from 'src/app/services/mongo.service';
import { NavigatorService } from 'src/app/services/navigator.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { StatuteAcceptDialogComponent } from '../common/statute-accept-dialog/statute-accept-dialog.component';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'app-view-landing-page',
  templateUrl: './view-landing-page.component.html',
  styleUrls: ['./view-landing-page.component.css']
})
export class ViewLandingPageComponent implements OnInit {

  public get treatUserAsLogger() {
    return this.userDataService.isUserLoggedIn &&
      this.userDataService.isUserOnboardingComplete;
  }

  userData: any;

  constructor(
    private userDataService: UserDataService,
    private navigator: NavigatorService,
    private mongoService: MongoService,
    private dialog: MatDialog,
    private stateService: StateService
  ) { 
  }
  
  async ngOnInit(): Promise<void> {
    this.userData = await this.mongoService.getUserDataByEmail(this.userDataService?.currentUser?.email);  
    if(this.userDataService.isUserLoggedIn){
      if ((!this.userDataService?.isUserAdmin && !this.userDataService?.isUserPanasonicAdmin) && (!this.userData.isPumpStatutAccepted || !this.userData.isAirConditionStatutAccepted)){
        this.dialog.open(StatuteAcceptDialogComponent, { disableClose: true, data: {
          title: '',
          message: '',
          isErrorInfo: true,
          okFunc: null
        }});
      }
    }
  }

  public redirectToLogin() : void {
    this.navigator.redirectToLoginScreen();
  }

  public redirectToBenefits() : void {
    this.navigator.redirectToBenefitsScreen();
  }

  public welcomeTextSecondPart(){
    if (this.stateService.getState() == 'state-pumps'){
      return 'pomp ciepła Panasonic';
    } else if (this.stateService.getState() == 'state-airconditioners'){
      return 'klimatyzacji Panasonic';
    } else return 'Panasonic'
  }
}
